import React from 'react'
import MarketingNavbar from '../../components/marketingNavbar';
import './style.scss'
import Footer from '../../components/footer';
import TextSection from './partials/text';

const TermsAndConditions = () => {
    return (
        <div className='terms__and__conditions'>
            <MarketingNavbar blue />
            <TextSection />
            <Footer onlyFooter />
        </div>
    )
}

export default TermsAndConditions